var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',[_vm._v("经度"+_vm._s(_vm.lon))]),_vm._v(" "),_c('span',[_vm._v("纬度"+_vm._s(_vm.lat))]),_vm._v(" "),_c('span',[_vm._v("精度"+_vm._s(_vm.accuracy))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-094248d0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/test.vue
// module id = null
// module chunks = 